module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "downloaddetail-container"
  }, [_c('div', {
    staticClass: "downloaddetail-content dib tl"
  }, [_c('el-breadcrumb', {
    staticClass: "content-breadcrumb",
    attrs: {
      "separator": " > "
    }
  }, [_c('el-breadcrumb-item', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首页")])]), _vm._v(" "), _c('el-breadcrumb-item', [_c('a', {
    attrs: {
      "href": "/dataDownload"
    }
  }, [_vm._v("资料下载")])]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.breadcrumb))])], 1), _vm._v(" "), _c('div', {
    staticClass: "content-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "downloaddetail-section1 dib"
  }, [_c('div', {
    staticClass: "section1-leftlist dib"
  }, [_c('div', {
    staticClass: "selectlist-container"
  }, [_c('div', {
    staticClass: "selectlist-header tc"
  }, [_vm._v("资料下载")]), _vm._v(" "), _vm._l((_vm.downloadList), function(item) {
    return _c('div', {
      staticClass: "selectlist-cell tl",
      class: (item.id === _vm.listValue) ? 'is-active' : '',
      attrs: {
        "value": item.id
      },
      on: {
        "click": function($event) {
          return _vm.clickCell(item.id)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "recommendDownload-container tc"
  }, [_c('div', {
    staticClass: "recommendDownload-header"
  }, [_vm._v("推荐下载")]), _vm._v(" "), _c('div', {
    staticClass: "recommendDownload-divider"
  }), _vm._v(" "), _c('ul', {
    staticClass: "recommendDownload-list tl"
  }, _vm._l((_vm.recommendList), function(item, index) {
    return _c('li', {
      staticClass: "recommendDownload-item",
      on: {
        "click": function($event) {
          return _vm.clickRecommend(index)
        }
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "recommendDownload-divider"
  }), _vm._v(" "), _c('img', {
    staticClass: "recommendDownload-wechat",
    attrs: {
      "src": require("../../assets/img/dataDownload/downloadDetail/wechat.png"),
      "alt": "关注微信公众号"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "recommendDownload-misc"
  }, [_vm._v("关注微信公众号")])])]), _vm._v(" "), _c('div', {
    staticClass: "section1-rightcontent dib"
  }, [_c('div', {
    staticClass: "title-image tc",
    style: ({
      'backgroundImage': 'url(' + _vm.imageSrc + ')'
    })
  }, [_c('div', {
    staticClass: "title-mask"
  }, [_c('h1', {
    staticClass: "misc"
  }, [_vm._v(_vm._s(_vm.contentTitle))]), _vm._v(" "), _c('el-button', {
    staticClass: "download-button",
    attrs: {
      "round": ""
    },
    on: {
      "click": _vm.dialogOpen
    }
  }, [_vm._v("立即下载")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content-main",
    domProps: {
      "innerHTML": _vm._s(_vm.contentData)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "section1-footer tc"
  }, [_c('el-button', {
    staticClass: "download-button",
    attrs: {
      "round": ""
    },
    on: {
      "click": _vm.dialogOpen
    }
  }, [_vm._v("立即下载")])], 1)]), _vm._v(" "), _c('download-panel', {
    ref: "downloadPanel"
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aac105ec"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dataDownload/dataDownloadDetail.vue
// module id = 674
// module chunks = 12